import { render, staticRenderFns } from "./AttendanceStatistics.vue?vue&type=template&id=4b510479"
import script from "./AttendanceStatistics.vue?vue&type=script&lang=js"
export * from "./AttendanceStatistics.vue?vue&type=script&lang=js"
import style0 from "./AttendanceStatistics.vue?vue&type=style&index=0&id=4b510479&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports